<template>
  <ppt-slide-viewer module-code="cq_rt" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "CqRt",
  components: { PptSlideViewer }
};
</script>
